import { Backend, buildFormData } from '@/_axios';

export default {
  list(projectId, params) {
    return Backend.get(`/project/${projectId}/ai_models/`, { params });
  },
  createData(projectId) {
    return Backend.get(`/project/${projectId}/ai_models/create`);
  },
  editData(projectId, id) {
    return Backend.get(`/project/${projectId}/ai_models/${id}/edit`);
  },
  create(projectId, data) {
    const formData = new FormData();
    buildFormData(formData, data);
    return Backend.post(
      `/project/${projectId}/ai_models/`, formData,
      { headers: { 'Content-Type': 'multipart/form-data' }, noForbidden: true }
    );
    // return Backend.post(`/project/${projectId}/ai_models/`, data);
  },

  update(projectId, data) {
    const formData = new FormData();
    buildFormData(formData, data);
    formData.append('_method', 'PUT');
    return Backend.post(
      `/project/${projectId}/ai_models/${data.id}`, formData,
      { headers: { 'Content-Type': 'multipart/form-data' }, noForbidden: true }
    );
    // return Backend.put(`/project/${projectId}/ai_models/${data.id}`, data);
  },
  delete(projectId, id) {
    return Backend.delete(`/project/${projectId}/ai_models/${id}`);
  },
};
